import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var RotateRight = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement(SvgFill, {
    d: "M15.885 18.748c0-1.294 1-2.289 2.301-2.289h23.513c1.3 0 2.301.995 2.301 2.289V42.13c0 1.294-1 2.289-2.301 2.289H18.186c-1.3 0-2.301-.995-2.301-2.289V18.748Zm2.301-.2c-.1 0-.2.1-.2.2V42.23s0 .1.1.1l.1.099h23.613s.1 0 .1-.1l.1-.1V18.749c0-.1-.1-.2-.2-.2H18.186Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M30.693 8.4c0 .497-.4.895-.9.994l-6.604 1.592c-.6.1-1.1-.199-1.301-.796-.1-.597.2-1.094.8-1.293l4.503-1.095C19.487 3.026 9.38 5.414 4.579 13.076c-3.903 6.269-3.002 14.13 1.6 19.304.4.398.3 1.094-.1 1.492-.4.398-1.1.299-1.5-.1-5.203-5.97-6.204-14.726-1.801-21.79C6.28 6.31 12.383 3.224 18.586 3.224c3.202 0 6.504.796 9.505 2.587l-1-4.08c-.1-.597.2-1.094.8-1.293.6-.1 1.1.199 1.301.796l1.6 6.667c-.1.298-.1.398-.1.497Z"
  })));
});
RotateRight.displayName = 'RotateRight';
RotateRight.defaultProps = {
  'aria-label': 'RotateRight'
};
export default RotateRight;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/RotateRight.js
// module id = 3899
// module chunks = 11